<template>
    <div class="row g-3 mb-4">
        <!-- NAGŁÓWEK W SPÓJNYM STYLU Z PRZEWIJANIEM -->
        <div ref="headerRef"
            class="col-12 d-flex justify-content-between align-items-center border-bottom pb-2 cursor-pointer"
            @click="toggleSection">
            <h6 class="fw-bold mb-0">{{ title }}</h6>
            <button type="button" class="btn btn-sm btn-link text-decoration-none p-0">
                <i class="bi" :class="sectionCollapse ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
            </button>
        </div>

        <!-- TREŚĆ SEKCJI -->
        <div class="col-12" v-show="sectionCollapse">

            <div class="row g-3 mb-3">
                <div class="col-12 col-md-6">
                    <label class="form-label">* Kwota pojazdu</label>
                    <input type="number" step="0.01" class="form-control" v-model="form.carPrice" placeholder="0.00" />
                </div>
                <div class="col-12 col-md-3">
                    <label class="form-label">* Waluta</label>
                    <select class="form-select" v-model="form.carCurrency">
                        <option v-for="r in dicts?.currencies" :key="r.ID || r.id || r" :value="r.name || r.label || r">
                            {{ r.name || r.label || r }}
                        </option>
                    </select>
                </div>
                <div class="col-12 col-md-3">
                    <label class="form-label">Termin do zapłaty</label>
                    <input type="date" class="form-control" v-model="form.dueDate" />
                </div>
            </div>

            <div class="row g-3 mb-3">
                <div class="col-12 col-md-6">
                    <label class="form-label">* Kwota zadatku</label>
                    <input type="number" step="0.01" class="form-control" v-model="form.depositAmount"
                        placeholder="0.00" />
                </div>
                <div class="col-12 col-md-3">
                    <label class="form-label">* Waluta</label>
                    <select class="form-select" v-model="form.depositCurrency">
                        <option v-for="r in dicts?.currencies" :key="r.ID || r.id || r" :value="r.name || r.label || r">
                            {{ r.name || r.label || r }}
                        </option>
                    </select>
                </div>
                <div class="col-12 col-md-3">
                    <label class="form-label">* Data końca umowy</label>
                    <input type="date" class="form-control" v-model="form.agreementEndDate" />
                </div>
            </div>

            <div v-if="form.euroRate" class="text-muted small">
                kurs euro: {{ form.euroRate }} zł z dnia: {{ form.euroRateDate }}
            </div>

            <div class="row g-3">


                <div class="col-12">
                    <hr class="my-1 text-muted opacity-25" />
                </div>

                <!-- 2. DYNAMICZNA LISTA FORUM PŁATNOŚCI (KOMPAKTOWA - 2 LINIE NA WIERSZ) -->
                <div class="col-12">
                    <label class="form-label fw-semibold mb-2">Formy i szczegóły płatności</label>

                    <div v-for="(pay, index) in paymentRows" :key="index"
                        class="p-3 mb-3 bg-light rounded border position-relative">
                        <!-- LINIA 1: KWOTA, TYP, DATA, WALUTA, USUWANIEL -->
                        <div class="row g-2 align-items-end mb-2">
                            <div class="col-12 col-sm-6 col-md-3">
                                <label class="form-label small text-muted mb-1">Kwota</label>
                                <input type="number" step="0.01" class="form-control form-control-sm"
                                    v-model="pay.amount" placeholder="0.00" required />
                            </div>

                            <div class="col-12 col-sm-6 col-md-3">
                                <label class="form-label small text-muted mb-1">Typ płatności</label>
                                <select class="form-select form-select-sm" v-model="pay.paymentType">
                                    <option v-for="r in filteredPaymentTypes" :key="r.ID || r.id || r"
                                        :value="r.name || r.label || r">
                                        {{ r.name || r.label || r }}
                                    </option>
                                </select>
                            </div>

                            <div class="col-12 col-sm-6 col-md-3">
                                <label class="form-label small text-muted mb-1">Data zapłaty</label>
                                <input type="date" class="form-control form-control-sm" v-model="pay.dueDate" required />
                            </div>

                            <div class="col-12 col-sm-4 col-md-2">
                                <label class="form-label small text-muted mb-1">Waluta</label>
                                <select class="form-select form-select-sm" v-model="pay.currency">
                                    <option v-for="r in dicts?.currencies" :key="r.ID || r.id || r"
                                        :value="r.name || r.label || r">
                                        {{ r.name || r.label || r }}
                                    </option>
                                </select>
                            </div>

                            <!-- Przycisk usunięcia wiersza (dostępny jeśli jest więcej niż jeden wiersz) -->
                            <div class="col-12 col-sm-2 col-md-1 d-flex justify-content-end">
                                <button type="button" class="btn btn-sm btn-outline-danger w-100"
                                    title="Usuń tę formę płatności" :disabled="paymentRows.length <= 1"
                                    @click="removePaymentRow(index)">
                                    <i class="bi bi-trash"></i>
                                </button>
                            </div>
                        </div>

                        <!-- LINIA 2: ZWOLNIENIA VAT + DANE BANKOWE DEALLERA -->
                        <div class="row g-2 align-items-end">
                            <div class="col-12 col-md-3">
                                <label class="form-label small text-muted mb-1">Powód zwolnienia z VAT</label>
                                <select class="form-select form-select-sm" v-model="pay.vatExemptReason">
                                    <option value="">Brak zwolnienia</option>
                                    <option v-for="r in dicts?.vatExemptReasons" :key="r.ID || r.id || r"
                                        :value="r.name || r.label || r">
                                        {{ r.name || r.label || r }}
                                    </option>
                                </select>
                            </div>

                            <div class="col-12 col-md-3">
                                <label class="form-label small text-muted mb-1">Opis zwolnienia z VAT</label>
                                <input type="text" class="form-control form-control-sm"
                                    v-model="pay.vatExemptDescription" placeholder="np. podstawa prawna" />
                            </div>

                            <div class="col-12 col-sm-6 col-md-2">
                                <label class="form-label small text-muted mb-1">Nazwa banku</label>
                                <input type="text" class="form-control form-control-sm" v-model="pay.bankName" />
                            </div>

                            <div class="col-12 col-sm-6 col-md-3">
                                <label class="form-label small text-muted mb-1">Nr rachunku bankowego</label>
                                <input type="text" class="form-control form-control-sm" v-model="pay.bankAccount" />
                            </div>

                            <div class="col-12 col-md-1 d-flex align-items-end">
                                <button type="button" class="btn btn-sm btn-outline-primary w-100"
                                    title="Pobierz dane bankowe z konta dealera"
                                    :disabled="loadingDealerDataIndex === index" @click="fetchDealerData(index)">
                                    <span v-if="loadingDealerDataIndex === index"
                                        class="spinner-border spinner-border-sm" role="status"></span>
                                    <i v-else class="bi bi-download"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- PRZYCISK DODAWANIA KOLEJNEGO WIERSZA -->
                <div class="col-12">
                    <button type="button" class="btn btn-sm btn-outline-success d-flex align-items-center gap-1"
                        @click="addPaymentRow">
                        <i class="bi bi-plus-circle"></i>
                        <span>Dodaj kolejną pozycję płatności</span>
                    </button>
                </div>

            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, watch, nextTick } from 'vue'
import apiClient from '@/api'
import { webAlert } from '@/utils/dialog'

const props = defineProps({
    modelValue: {
        type: Object,
        required: true
    },
    sellerModel: {
        type: Object,
        default: () => ({ bankName: '', bankAccount: '' })
    },
    dicts: {
        type: Object,
        default: () => ({
            paymentStatuses: [],
            paymentTypes: [],
            currencies: [],
            vatExemptReasons: []
        })
    },
    title: { type: String, default: '7. Cena i płatność' }

})

const emit = defineEmits(['update:modelValue', 'update:sellerModel'])

const filteredPaymentTypes = computed(() => {
    const list = props.dicts?.paymentTypes || []
    return list.filter(r => {
        const val = r.name || r.label || r
        return String(val).toLowerCase() !== 'kredyt'
    })
})

const headerRef = ref(null)
const sectionCollapse = ref(false)
const loadingDealerDataIndex = ref(null)

// Główny obiekt formularza
const form = computed({
    get: () => props.modelValue,
    set: (val) => emit('update:modelValue', val)
})

const seller = computed({
    get: () => props.sellerModel || props.modelValue?.seller || {},
    set: (val) => emit('update:sellerModel', val)
})

// Inicjalizacja tablicy płatności (form.payments)
if (!form.value.payments || !Array.isArray(form.value.payments) || form.value.payments.length === 0) {
    form.value.payments = [
        {
            amount: 0,
            paymentType: form.value.paymentType || (props.dicts?.paymentTypes?.[0] || 'Przelew'),
            dueDate: form.value.dueDate || '',
            currency: form.value.currency || 'PLN',
            vatExemptReason: form.value.vatExemptReason || '',
            vatExemptDescription: form.value.vatExemptDescription || '',
            bankName: seller.value?.bankName || '',
            bankAccount: seller.value?.bankAccount || ''
        }
    ]
}

const paymentRows = computed({
    get: () => form.value.payments || [],
    set: (val) => {
        form.value.payments = val
    }
})

// Synchronizacja domyślnych pól w starym formacie z pierwszym elementem (dla wstecznej kompatybilności)
watch(
    () => form.value.payments,
    (newPayments) => {
        if (newPayments && newPayments.length > 0) {
            const first = newPayments[0]
            form.value.paymentType = first.paymentType
            form.value.dueDate = first.dueDate
            form.value.currency = first.currency
            form.value.vatExemptReason = first.vatExemptReason
            form.value.vatExemptDescription = first.vatExemptDescription
        }
    },
    { deep: true }
)

const toggleSection = async () => {
    sectionCollapse.value = !sectionCollapse.value
    if (sectionCollapse.value) {
        await nextTick()
        headerRef.value?.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
}

// Dodawanie kolejnej pozycji płatności
const addPaymentRow = () => {
    const defaultType = props.dicts?.paymentTypes?.[0].name || 'Przelew'
    const defaultCurrency = props.dicts?.currencies?.[0].name || 'PLN'

    paymentRows.value.push({
        amount: 0,
        paymentType: defaultType,
        dueDate: '',
        currency: defaultCurrency,
        vatExemptReason: '',
        vatExemptDescription: '',
        bankName: seller.value?.bankName || '',
        bankAccount: seller.value?.bankAccount || ''
    })
}

// Usuwanie pozycji płatności
const removePaymentRow = (index) => {
    if (paymentRows.value.length > 1) {
        paymentRows.value.splice(index, 1)
    }
}

// Pobieranie danych bankowych z ustawień dealera dla wybranego wiersza
const fetchDealerData = async (rowIndex) => {
    loadingDealerDataIndex.value = rowIndex
    try {
        const response = await apiClient.post({ action: 'get-invoice-data' })
        const resData = response.data

        if (resData?.data) {
            if (resData.data.bankName) {
                paymentRows.value[rowIndex].bankName = resData.data.bankName
                seller.value.bankName = resData.data.bankName
            }
            if (resData.data.bankAccount) {
                paymentRows.value[rowIndex].bankAccount = resData.data.bankAccount
                seller.value.bankAccount = resData.data.bankAccount
            }
        } else if (resData?.message) {
            webAlert(resData)
        } else {
            webAlert('Nie udało się pobrać danych dealera.')
        }
    } catch (error) {
        console.error('Błąd podczas pobierania danych dealera:', error)
        webAlert('Wystąpił błąd podczas połączenia z API.')
    } finally {
        loadingDealerDataIndex.value = null
    }
}
</script>

<style scoped>
.cursor-pointer {
    cursor: pointer;
    user-select: none;
}
</style>